import {Schema, type} from "@colyseus/schema";

export type Position = { x: number, y: number }

export class GameSchema extends Schema {
    @type("string") id: string
    @type("number") x = 0
    @type("number") y = 0

    get printableId(): string { return `${this.id}` }

    get position(): Position { return {x: this.x, y: this.y}}

    setPosition(xOrPos: number | Position, y?: number) {
        if (typeof xOrPos === 'number') {
            this.x = xOrPos
            this.y = y
        } else {
            this.x = xOrPos.x
            this.y = xOrPos.y
        }
    }
}
